import React from 'react';
import { Clickable, Text } from '@moda/om';
import ExitIcon from '@moda/icons/exit-16';
import { useUrlParams } from '../../../hooks/useUrlParams';
import { useLook } from '../useLook';
import { LooksCarouselItemHeaderNavigation } from '../LooksCarouselItemHeaderNavigation';

import './LooksCarouselItemHeader.scss';

export const LooksCarouselItemHeader: React.FC = () => {
  const {
    params: { look: lookId },
    removeParams
  } = useUrlParams();

  const { trunkshowName, numberOfVariants, loading } = useLook(lookId);

  return (
    <div className="LooksCarouselItemHeader">
      <div className="LooksCarouselItemHeader__info">
        <LooksCarouselItemHeaderNavigation />

        {!loading && (
          <Text>{`${trunkshowName} - ${numberOfVariants} ${
            numberOfVariants !== 1 ? 'Items' : 'Item'
          }`}</Text>
        )}
      </div>

      <Clickable
        className="LooksCarouselItemHeader__close-button"
        onClick={() => removeParams(['look'])}
      >
        <ExitIcon />
      </Clickable>
    </div>
  );
};
